import type {TableConfiguration} from 'schema/table/types';
import type {
  MergeSuggestion,
  MergeSuggestionType,
} from 'services/mergeSuggestions/types';
import {useLocalization} from 'localization';

export const useMergeSuggestionTableConfiguration =
  (): TableConfiguration<MergeSuggestion> => {
    const {t} = useLocalization();
    return {
      partValueRenderers: {
        type: ({value}) =>
          t(`page.mergeSuggestion.type.${value as MergeSuggestionType}.label`),
      },
      defaultColumns: [
        {
          name: 'created',
          visible: true,
          width: 115,
        },
        {
          name: 'type',
          visible: true,
        },
        {
          name: 'targetName',
          visible: true,
          width: 300,
        },
        {
          name: 'sourceName',
          visible: true,
          width: 300,
        },
        {
          name: 'description',
          visible: true,
          width: 200,
        },
        {
          name: 'targetId',
          visible: false,
        },
        {
          name: 'sourceId',
          visible: false,
        },
      ],
    };
  };
